import { configureStore } from "@reduxjs/toolkit";

import userInfoReducer from "./userInfo";
import loginReducer from "./login";
import SOPViewerReducer from "./SOPViewer";
import auditDocumentViewerReducer from "./AuditDocumentViewer";

import projectListReducer from "../../WorkingTimeTable/WorkRecord/Redux/projectList";
import taskListReducer from "../../WorkingTimeTable/WorkRecord/Redux/taskList";
import workRecordReducer from "../../WorkingTimeTable/WorkRecord/Redux/workRecord";

import universityListReducer from "../../CurriculumVitae/Redux/universityList";
import studyListReducer from "../../CurriculumVitae/Redux/studyList";

import jobDescrReducer from "../../PersonalRecord/Redux/jobDescr";

import paymentReducer from "../../SalesManagement/Payment/PaymentStatus/Redux/payment";
import vendorContractReducer from "../../SalesManagement/Payment/Vendor/Redux/vendorContract";
import salesReducer from "../../SalesManagement/Sales/Redux/sales";
import clinicalSiteReducer from "../../SalesManagement/Sales/Info/ClinicalSiteInfo/Redux/clinicalSite";
import sponsorInfoReducer from "../../SalesManagement/Sales/Info/SponsorInfo/Redux/sponsorInfo";
// import IRBTaskReducer from "../../SalesManagement/Sales/IRB/Redux/IRBTask";
import IRBReducer from "../../SalesManagement/Sales/IRBProjectStatus/Redux/IRB";
import siteVisitReducer from "../../SalesManagement/Sales/SiteVisits/Redux/siteVisit";
import SAEReducer from "../../SalesManagement/Sales/SafetyReporting/Redux/sae";

import trainingTrackerReducer from "../../Training/TrainingTracker/Redux/Tracker";

import contractReducer from "../../ProjectSetup/Redux/contract";
import feasibilityReducer from "../../Feasibility/Redux/feasibility";

export const store = configureStore({
  reducer: {
    userInfo: userInfoReducer,
    login: loginReducer,
    SOPViewer: SOPViewerReducer,
    projectList: projectListReducer,
    taskList: taskListReducer,
    workRecord: workRecordReducer,
    universityList: universityListReducer,
    studyList: studyListReducer,
    career: jobDescrReducer,
    auditDocumentViewer: auditDocumentViewerReducer,
    payment: paymentReducer,
    vendorContract: vendorContractReducer,
    sales: salesReducer,
    clinicalSite: clinicalSiteReducer,
    sponsorInfo: sponsorInfoReducer,
    // IRBTask: IRBTaskReducer,
    IRB: IRBReducer,
    siteVisit: siteVisitReducer,
    SAE: SAEReducer,
    trainingTracker: trainingTrackerReducer,
    contract: contractReducer,
    feasibility: feasibilityReducer,
  },
});
